module.exports = __webpack_public_path__ + "static/media/Polygon 9.548f1893.svg";